import { SiDocker } from 'react-icons/si'

export const DockerTech = () => {
    return (
        <div>
        <SiDocker />
        <h4>Docker</h4>
        </div>
    )
}